import { createFileRoute } from '@tanstack/react-router';
import { RouteGuard } from '../../lib/route-guard.js';
import { ProductCreateForm } from '../../modules/products/product-create-form.js';

export const Route = createFileRoute('/products/new')({
  component: NewProductPage,
});

// eslint-disable-next-line react-refresh/only-export-components
function NewProductPage() {
  return (
    <RouteGuard route="/products/new">
      <div>
        <ProductCreateForm />
      </div>
    </RouteGuard>
  );
}
